<mat-sidenav-container class="container">
    <mat-sidenav #sidenav mode="side" opened class="sidenav" [fixedInViewport]="options.value.fixed" [fixedTopGap]="options.value.top" [fixedBottomGap]="options.value.bottom">
        <div routerLink="profile" routerLinkActive="active" class="pink">MY PROFILE</div>
        <div routerLink="search" routerLinkActive="active" class="grey">JOB SEARCH </div>
        <div routerLink="tables" routerLinkActive="active" class="peach">TABLE EXAMPLE</div>
        <div routerLink="interviews" routerLinkActive="active" class="light-pink">INTERVIEWS</div>
        <div routerLink="calendar" routerLinkActive="active" class="yellow">CALENDAR</div>
        <div routerLink="notes" routerLinkActive="active" class="blue-grey">NOTES</div>
        <div routerLink="settings" routerLinkActive="active" (click)="sidenav.close()"  class="dark-grey">SETTINGS</div>
    </mat-sidenav>
    
    <mat-sidenav-content class="toggle-container">
        <button mat-button id="bookmark_button" (click)="sidenav.toggle()">MENU</button>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>